/* eslint-disable no-unused-vars */
import axios from '@/axios'
const resource = '/v1/stay/search'

import menu_plan_list from '@/jsons-data/mocks/menu_plan_list.json'
import search_menu from '@/jsons-data/mocks/search_menu.json'
import search_menu_list from '@/jsons-data/mocks/search_menu_list.json'
import search_menu_public_stay from '@/jsons-data/mocks/search_menu_public_stay.json'
import region1 from '@/jsons-data/mocks/areas/region-1.json'
import region2 from '@/jsons-data/mocks/areas/region-2.json'
import region3 from '@/jsons-data/mocks/areas/region-3.json'
import region4 from '@/jsons-data/mocks/areas/region-4.json'
import region6 from '@/jsons-data/mocks/areas/region-6.json'
import region7 from '@/jsons-data/mocks/areas/region-7.json'
import region8 from '@/jsons-data/mocks/areas/region-8.json'
import region9 from '@/jsons-data/mocks/areas/region-9.json'
import region10 from '@/jsons-data/mocks/areas/region-10.json'
import region11 from '@/jsons-data/mocks/areas/region-11.json'
import region12 from '@/jsons-data/mocks/areas/region-12.json'
import region13 from '@/jsons-data/mocks/areas/region-13.json'

const REGION = {
  'region-1': region1,
  'region-2': region2,
  'region-3': region3,
  'region-4': region4,
  'region-6': region6,
  'region-7': region7,
  'region-8': region8,
  'region-9': region9,
  'region-10': region10,
  'region-11': region11,
  'region-12': region12,
  'region-13': region13
}

export default {
  searchTabi(params) {
    // console.log('**************************************************')
    // console.log(JSON.stringify(params))
    // return axios.get(`${resource}/tabi`, { params })
    return axios.get(`${resource}/tabi`, { params })
  },
  searchPlan(params) {
    // console.log('**************************************************')
    // console.log(JSON.stringify(params))
    // return axios.get(`${resource}/plan`, { params })
    return axios.get(`${resource}/plan`, { params })
  },
  searchPlanMock(params) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/plan`, { params }).then(
        (response) => {
          resolve(menu_plan_list)
        },
        () => {
          resolve(menu_plan_list)
        }
      )
    })
  },
  searchMenu(body, params) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        axios.post(`${resource}/menu`, body, { params }).then(
          (response) => {
            resolve(response.data)
          },
          () => {
            resolve(search_menu)
          }
        )
      }, 3000)
    })
  },
  searchMenuList(params) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        axios.get('/v1/stay/menu/menu-list', { params }).then(
          (response) => {
            resolve(response.data)
          },
          (error) => {
            resolve(error)
          }
        )
      }, 1000)
    })
  },

  /* ========= PUBLIC STAY ========= */
  searchMenuPublicStay(body, params) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/public/stay`, body, { params }).then(
        (response) => {
          resolve(response.data)
        },
        () => {
          resolve(search_menu_public_stay.data)
        }
      )
    })
  },

  getCodesArea(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${resource}/codes/area`, { params })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          if (params.areaSmlClassCd) {
            resolve({
              data: {
                areaLrgClasses: [
                  {
                    areaLrgClassNm: '\u6771\u5317',
                    areaLrgClassCd: 'region-2',
                    areaMidClasses: [
                      {
                        areaMidClassNm: '\u9752\u68ee\u770c',
                        areaMidClassCd: 'aomori',
                        areaSmlClasses: [
                          {
                            areaSmlClassNm:
                              '\u767d\u795e\u5c71\u5730\u30fb\u897f\u6d25\u8efd',
                            areaDtlClasses: [
                              {
                                areaDtlClassNm:
                                  '\u767d\u795e\u5c71\u5730\u30fb\u897f\u6d25\u8efd',
                                areaDtlClassCd: 'ntsugaru'
                              }
                            ],
                            areaSmlClassCd: 'ntsugaru'
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            })
          } else if (params.areaMidClassCd) {
            resolve({
              data: {
                areaLrgClasses: [
                  {
                    areaLrgClassNm: '\u6771\u5317',
                    areaLrgClassCd: 'region-2',
                    areaMidClasses: [
                      {
                        areaMidClassNm: '\u9752\u68ee\u770c',
                        areaMidClassCd: 'aomori',
                        areaSmlClasses: [
                          {
                            areaSmlClassNm: '\u9752\u68ee\u30fb\u6d45\u866b\u6e29\u6cc9',
                            areaSmlClassCd: 'aomori'
                          },
                          {
                            areaSmlClassNm:
                              '\u6d25\u8efd\u534a\u5cf6\u30fb\u4e94\u6240\u5ddd\u539f',
                            areaSmlClassCd: 'tsugaru'
                          },
                          {
                            areaSmlClassNm:
                              '\u767d\u795e\u5c71\u5730\u30fb\u897f\u6d25\u8efd',
                            areaSmlClassCd: 'ntsugaru'
                          },
                          {
                            areaSmlClassNm: '\u5f18\u524d\u30fb\u9ed2\u77f3',
                            areaSmlClassCd: 'hirosaki'
                          },
                          {
                            areaSmlClassNm:
                              '\u516b\u7532\u7530\u30fb\u5341\u548c\u7530\u6e56\u30fb\u5965\u5165\u702c',
                            areaSmlClassCd: 'towadako'
                          },
                          {
                            areaSmlClassNm:
                              '\u516b\u6238\u30fb\u4e09\u6ca2\u30fb\u4e03\u6238\u5341\u548c\u7530',
                            areaSmlClassCd: 'hachinohe'
                          },
                          {
                            areaSmlClassNm:
                              '\u4e0b\u5317\u30fb\u5927\u9593\u30fb\u3080\u3064',
                            areaSmlClassCd: 'shimokita'
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            })
          } else if (REGION[params.areaLrgClassCd]) {
            resolve({
              data: REGION[params.areaLrgClassCd]
            })
          }
        })
    })
  },

  async getLargeCodesArea() {
    let data = []
    const regions = [
      'region-1',
      'region-2',
      'region-3',
      'region-4',
      'region-6',
      'region-7',
      'region-8',
      'region-9',
      'region-10',
      'region-11',
      'region-12',
      'region-13'
    ]
    const workers = []
    regions.forEach((rg) => {
      workers.push(this.getCodesArea({ areaLrgClassCd: rg }))
    })
    const rgs = await Promise.allSettled(workers)
    rgs.forEach((rg) => {
      const rgRes = rg?.value
      const dataRg = rgRes?.data?.areaLrgClasses?.[0]?.areaMidClasses?.map((item) => {
        return {
          ...item,
          areaLrgClassNm: rgRes?.data?.areaLrgClasses?.[0]?.areaLrgClassNm,
          areaLrgClassCd: rgRes?.data?.areaLrgClasses?.[0]?.areaLrgClassCd
        }
      })
      if (dataRg?.length) data.push(...dataRg)
    })
    return { data }
  }
}
